import { useNavigateBack } from '@exam-management/common/hooks';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { QContentCreateHeader } from '@exam-management/qcontent-creation';
import { useParams } from '@exam-management/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QContentItemSetCreateLayout() {
  const { qBankStructureInformation } = useQBankStructure();
  const { structureId } = useParams('/qbank-structures/:structureId');

  const { handleBack } = useNavigateBack({
    fallbackPath: '/qbank-structures/:structureId/qcontents',
    matchPatterns: '/qbank-structures/:structureId/qcontents',
    fallbackParams: { structureId },
  });

  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.QBANK.QUESTION.CREATE]}>
      <QContentCreateHeader
        title='Add New Item Set'
        courseID={qBankStructureInformation.code.toString()}
        qbsName={qBankStructureInformation.name}
        onBack={handleBack}
      />

      <Outlet />
    </PermissionGuard>
  );
}
